
import React from "react";
import { connect } from 'react-redux';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Row,
  Col,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label

} from "reactstrap";
import { utils } from '../../helpers';
import { PanelHeader } from "components";
import ErrorModal from "../Components/ErrorModal"
import SweetAlert from "react-bootstrap-sweetalert";
import { roleConstants, permissionConstants, loopbackConstants } from '../../constants';
import { loopbackActions, userActions } from "../../actions";
import { history } from '../../helpers';
import { loopbackService } from '../../services';
import { selectedProjectChangeListeners } from '../../components/Header/Header';
import { permissions } from '../../helpers';
import { withTranslation } from 'react-i18next';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import ReactTable from "react-table";

import Loader from "../Components/Loader";
import "../../assets/css/context-menu.css";
import DailyProfile from "./DailyProfile";
import WeeklyProfile from "./WeeklyProfile";
import User from '../../entities/User';

const MODEL_DAILY = "timerprofiledaily";
const MODEL_WEEKLY = "timerprofileweekly";

class TimerProfilesComponent extends React.Component {


  constructor(props) {
    super(props);

    const { t } = props;
    this.state = {
      loading: false,
      errors: [],
      alert: null,
      model: MODEL_DAILY,
      profiles: {
        [MODEL_DAILY]: [],
        [MODEL_WEEKLY]: []
      },
      selectedProfile: {
        [MODEL_DAILY]: null,
        [MODEL_WEEKLY]: null
      },
      isEditingProfile: {
        [MODEL_DAILY]: false,
        [MODEL_WEEKLY]: false
      },
      editingProfile: {
        [MODEL_DAILY]: null,
        [MODEL_WEEKLY]: null
      },
      saving: false,
      validationError: null
    };

    selectedProjectChangeListeners.push(() => {
      this.setState({
        selectedProfile: {
          [MODEL_DAILY]: null,
          [MODEL_WEEKLY]: null
        },
        isEditingProfile: {
          [MODEL_DAILY]: false,
          [MODEL_WEEKLY]: false
        },
        editingProfile: {
          [MODEL_DAILY]: null,
          [MODEL_WEEKLY]: null
        },
        profiles: {
          [MODEL_DAILY]: [],
          [MODEL_WEEKLY]: []
        }
      });
      this.fetchData(MODEL_DAILY);
    });

    this.handleSavedProfile = this.handleSavedProfile.bind(this);
    this.handleDeletedProfile = this.handleDeletedProfile.bind(this);
    this.handleCancelProfile = this.handleCancelProfile.bind(this);
    this.getLegacyTimerFlag = this.getLegacyTimerFlag.bind(this);

  }

  componentDidMount() {
    this.fetchData(MODEL_DAILY);
  }

  componentWillMount() {
    this.getLegacyTimerFlag();
  }

  getLegacyTimerFlag = function() {
    // Codice per discriminare il funzionamento dei nuovi profili timer
    this.projects = JSON.parse(localStorage.getItem('projects'));
    this.projectId = parseInt(localStorage.getItem('selectedProjectId'));
    this.projectSelected = this.projects.find(p => p.id == this.projectId);
    this.legacyTimer = this.projectSelected.legacyTimerProfiles;
  }

  /**
   * Carica i dati del model passato come argomento.
   * @param {*} model 
   */
  async fetchData(model) {

    let { profiles, selectedProfile, editingProfile, isEditingProfile } = this.state;

    let precId = selectedProfile[model] && selectedProfile[model].id;

    // impostazione flag timer legacy
    this.getLegacyTimerFlag();

    selectedProfile[model] = null;
    editingProfile[model] = null;
    isEditingProfile[model] = false;
    profiles[model] = [];

    this.setState({
      model,
      loading: true,
      profiles,
      selectedProfile,
      editingProfile,
      isEditingProfile
    });

    try {

      profiles[model] = await loopbackService.list('plant', model);

      if (precId) {
        for (let profile of profiles[model]) {
          if (profile.id === precId) {
            selectedProfile[model] = profile;
            break;
          }
        }
      }
      else {
        selectedProfile[model] = (profiles[model].length > 0 ? profiles[model][0] : null);
      }


      this.setState({ loading: false, profiles, selectedProfile });

    } catch (error) {

      this.setState({
        loading: false,
        errors: [error]
      });

    }
  }


  render() {
    let {
      errors,
      status
    } = this.state;

    return (
      <div className="full-height-no-header timer-profiles">
        {this.state.alert}
        {errors && errors.length > 0 && <ErrorModal error={errors} onClickHandler={() => { this.setState({ errors: [] }) }} />}
        <PanelHeader
          size="sm"
        />
        <div className="content full-height">
          <Row className="full-height ">
            <Col xs={12} md={3} className="">
              {this.renderProfiles()}
            </Col>
            <Col xs={12} md={9} className="">
              {this.renderProfile()}
            </Col>
          </Row>
        </div>
      </div>
    );
  }



  renderProfiles() {

    const user = User.current();
    const isGuest = (user.userRoleId == roleConstants.GUEST);

    const { t } = this.props;

    const { model, loading, profiles, selectedProfile, editingProfile, isEditingProfile } = this.state;

    return (
      <div className="side-menu">

        <Nav pills className="nav-pills-primary tab-title-profiles">
          <NavItem>
            <NavLink
              className={model === MODEL_DAILY ? "active" : ""}
              onClick={() => { this.fetchData(MODEL_DAILY); }}
            >
              {t("Giornalieri")}
            </NavLink>
          </NavItem>
          { this.legacyTimer && (
            <NavItem>
            <NavLink
              className={model === MODEL_WEEKLY ? "active" : ""}
              onClick={() => { this.fetchData(MODEL_WEEKLY); }}
            >
              {t("Settimanali")}
            </NavLink>
          </NavItem> 
          )}
        </Nav>

        <div className="side-menu-wrapper">
          <div className="side-menu-header" >
            <div className="search-bar">
              <span >{t("Profili")}</span>
              <Button
                color="info"
                onClick={() => this.addProfile()}
                disabled={isGuest}
              >
                {t("Nuovo")}
              </Button>

            </div>

          </div>

          <div className="side-menu-body">

            <ReactTable
              // TheadComponent = { props => null }
              className="table-profiles"
              showPagination={false}
              showPageSizeOptions={true}
              loading={loading}
              data={profiles[model]}
              noDataText={""}
              LoadingComponent={() => <Loader loading={loading} />}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {

                  isEditingProfile[model] = false;
                  editingProfile[model] = null;

                  return {
                    onClick: () => {
                      selectedProfile[model] = rowInfo.original,
                        this.setState({
                          selectedProfile,
                          isEditingProfile,
                          editingProfile
                        })
                    },
                    className: (rowInfo.original === selectedProfile[model] ? "active" : "")
                  }
                } else {
                  return {}
                }
              }}
              columns={[
                {
                  Header: t("Nome"),
                  accessor: "label",
                  Filter: ({ filter, onChange }) => (
                    <input
                      onChange={event => onChange(event.target.value)}
                      value={filter ? filter.value : ''}
                      placeholder={t("Search...")}
                      style={{
                        width: '100%'
                      }}
                    />
                  ),
                  filterable: true
                }
              ]}
            />
          </div>
        </div>
      </div>
    );
  }

  renderWeekly() {
    return (
      <p>Settimanale</p>
    );
  }

  renderProfile() {
    const { t } = this.props;
    const { model, profiles, selectedProfile, editingProfile, isEditingProfile } = this.state;

    if (!selectedProfile[model] && !editingProfile[model]) {
      return null;
    }

    if (model === MODEL_DAILY) {
      return (
        <DailyProfile
          editingProfile={editingProfile[MODEL_DAILY]}
          selectedProfile={selectedProfile[MODEL_DAILY]}
          isEditingProfile={isEditingProfile[MODEL_DAILY]}
          handleDeletedProfile={this.handleDeletedProfile}
          handleSavedProfile={this.handleSavedProfile}
          handleCancelProfile={this.handleCancelProfile}
          legacyTimer={this.legacyTimer}
        />
      )
    }
    else
      return (
        <WeeklyProfile
          dailyProfiles={profiles[MODEL_DAILY]}
          editingProfile={editingProfile[MODEL_WEEKLY]}
          selectedProfile={selectedProfile[MODEL_WEEKLY]}
          isEditingProfile={isEditingProfile[MODEL_WEEKLY]}
          handleDeletedProfile={this.handleDeletedProfile}
          handleSavedProfile={this.handleSavedProfile}
          handleCancelProfile={this.handleCancelProfile}
        />

      )




  }


  addProfile() {

    let { model, editingProfile, isEditingProfile, selectedProfile } = this.state;
    let currentProjectId = utils.getSelectedProject();

    if (model === MODEL_DAILY) {

      if(this.legacyTimer===true) {
        editingProfile[model] = {
          "label": "",
          "projectId": currentProjectId,
          "transition1": { mode: "sunset", timer: 0, outValue: 100, enable: true, type: "dimmering" },
          "transition2": { mode: "absolute", timer: 0, outValue: 100, enable: true, type: "dimmering" },
          "transition3": { mode: "absolute", timer: 0, outValue: 100, enable: true, type: "dimmering" },
          "transition4": { mode: "absolute", timer: 0, outValue: 100, enable: true, type: "dimmering" },
          "transition5": { mode: "sunrise", timer: 0, outValue: 0, enable: true, type: "dimmering" },
        }  
      }
      else {
        editingProfile[model] = {
          "label": "",
          "projectId": currentProjectId,
          "dailyTransitions": [
            { "id": 1, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 2, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 3, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 4, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 5, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 6, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 7, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 8, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 9, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 10, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 11, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
            { "id": 12, "enable": false, "mode": "absolute", "type": "dimmering", "timer": 0, "outValue": 0 },
          ]
        }  
      }

    } else if (model === MODEL_WEEKLY) {

      editingProfile[model] = {
        "label": "",
        "projectId": currentProjectId,
        "monFriProfileId": 0,
        "satProfileId": 0,
        "sunProfileId": 0
      }

    }

    isEditingProfile[model] = true;
    selectedProfile[model] = null;

    this.setState({ isEditingProfile, editingProfile, selectedProfile });
  }


  handleCancelProfile() {
    const { model, editingProfile, isEditingProfile } = this.state;
    editingProfile[model] = null;
    isEditingProfile[model] = null;
    this.setState({ editingProfile, isEditingProfile })
  }

  handleDeletedProfile() {

    let { model, profiles, selectedProfile } = this.state;

    let prev = null, ret = [];
    for (let profile of profiles[model]) {
      if (profile === selectedProfile[model]) {
        if (ret.length > 0) prev = ret[ret.length - 1];
      }
      else {
        ret.push(profile);
      }
    }

    if (prev) {
      selectedProfile[model] = prev;
    }
    else if (ret.length > 0) {
      selectedProfile[model] = ret[0];
    }
    else {
      selectedProfile[model] = null;
    }

    profiles[model] = ret;

    this.setState({ profiles, selectedProfile });

  }



  handleSavedProfile(savedProfile) {
    let { model, profiles, selectedProfile, isEditingProfile, editingProfile } = this.state;
    if (!selectedProfile[model]) {
      profiles[model].unshift(savedProfile);
    } else {
      let ret = [];
      for (let profile of profiles[model]) {
        if (profile === selectedProfile[model]) {
          ret.push(savedProfile);
        }
        else {
          ret.push(profile);
        }
      }
      profiles[model] = ret;
    }

    selectedProfile[model] = savedProfile;
    isEditingProfile[model] = false;
    editingProfile[model] = null;

    this.setState({
      isEditingProfile,
      editingProfile,
      selectedProfile,
      saving: false,
      profiles
    });


  }




}





function mapStateToProps(state) {
  return {};
}

const TimerProfiles = withTranslation()(connect(mapStateToProps)(TimerProfilesComponent));
export default TimerProfiles;






// WEBPACK FOOTER //
// ./src/views/TimerProfiles/TimerProfiles.jsx